import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'antd/dist/antd.css'
import 'font-awesome/css/font-awesome.min.css'
import './index.css'
import App from './App'
/*import * as Sentry from "@sentry/react"
import {Integrations} from "@sentry/tracing"

Sentry.setTag('webapp', '3D Webapp')
Sentry.init({
    dsn: "https://f0d679ab4e494986814dae8690f54dbe@sentry.merch8.com/20",
    integrations: [new Integrations.BrowserTracing(),],
    tracesSampleRate: 1.0,
    environment: "production"
})*/

ReactDOM.render(<App/>, document.getElementById('root'))
